import { defineComponent as t, createBlock as l, openBlock as r, unref as p, mergeProps as d, withCtx as u, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconMoney",
  __name: "IconMoney",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (c, n) => (r(), l(p(i), d(a, { "view-box": "0 0 24 24" }), {
      default: u(() => [...n[0] || (n[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M8.75 10.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M12 8.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M21.75 5.5a1.25 1.25 0 0 0-1.25-1.25h-17A1.25 1.25 0 0 0 2.25 5.5v10a1.25 1.25 0 0 0 1.25 1.25h17a1.25 1.25 0 0 0 1.25-1.25v-10m-4.17.25H6.42a3.505 3.505 0 0 1-2.67 2.67v4.16a3.505 3.505 0 0 1 2.67 2.67h11.16a3.505 3.505 0 0 1 2.67-2.67V8.42a3.505 3.505 0 0 1-2.67-2.67",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M5 18.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H5" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
